import React from "react";
import ReportingChart from "../Reporting/ReportingChart";
import _ from "lodash";
import gql from "graphql-tag";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";

const ECRITURELINE_CREATED_SUBSCRIPTION = gql`
  subscription onEcritureLineCreated($companyId: ID!) {
    ecritureLineCreated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_UPDATED_SUBSCRIPTION = gql`
  subscription onEcritureLineUpdated($companyId: ID!) {
    ecritureLineUpdated(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const ECRITURELINE_DELETED_SUBSCRIPTION = gql`
  subscription onEcritureLineDeleted($companyId: ID!) {
    ecritureLineDeleted(companyId: $companyId) {
      id
      journal
      amount
      libelle
      libelleExport
      dateOperation
      dateLettrage
      labelLettrage
      tiersClient {
        id
      }
      project {
        id
        tiersClient {
          id
        }
      }
      article {
        id
      }
      category {
        id
      }
    }
  }
`;

const LETTRAGE_DONE = gql`
  subscription onEcritureLineLettrageDone($companyId: ID!) {
    ecritureLineLettrageDone(companyId: $companyId) {
      date
    }
  }
`;

class TreasuryChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingMore: false
    };
    this.startCursorArray = [];
    this.startCursorArrayAlternate = [];
  }

  componentDidUpdate() {

    // console.log("118 - data=", this.props.data);
    const data =
      this.props.data && this.props.data.ecritureLinesConnectionForTreasury;

    if (!!!data) {
      this.startCursorArray = [];
      // return;
    }
    else {
      var pageInfo = data && data.pageInfo;

      const startCursor = pageInfo && pageInfo.startCursor;
      if (this.startCursorArray.includes(startCursor)) {
        console.log("128 - already in array:", startCursor);
      }
      else {
        this.startCursorArray.push(startCursor);

        if (pageInfo.hasNextPage) {
          console.log("139 - LoadMore...", startCursor);
          this.props.onLoadMore(
            pageInfo.endCursor,
            "ecritureLinesConnectionForTreasury"
          );
        }
      }
    }

    // alternate
    const dataAlternate =
      this.props.data && this.props.data.ecritureLinesConnectionForTreasury2;

    if (!!!dataAlternate) {
      this.startCursorArrayAlternate = [];
      // return;
    }
    else {
      var pageInfoAlternate = dataAlternate && dataAlternate.pageInfo;

      const startCursorAlternate = pageInfoAlternate && pageInfoAlternate.startCursor;
      if (this.startCursorArrayAlternate.includes(startCursorAlternate)) {
        console.log("175 - already in array2:", startCursorAlternate);
      }
      else {
        if (startCursorAlternate)
          this.startCursorArrayAlternate.push(startCursorAlternate);

        if (pageInfoAlternate.hasNextPage) {
          console.log("181 - LoadMore2...", startCursorAlternate);
          this.props.onLoadMore(
            pageInfoAlternate.endCursor,
            "ecritureLinesConnectionForTreasury2"
          );
        }
      }
    }

    // const pageInfoAlternate = dataAlternate && dataAlternate.pageInfo;

    // if (pageInfoAlternate && pageInfoAlternate.hasNextPage) {
    //   if (this.state.loadingMore === false)
    //     this.setState({ loadingMore: true });
    //   console.log("153 - loadingMore=", this.state.loadingMore);

    //   const startCursor = pageInfoAlternate && pageInfoAlternate.startCursor;
    //   if (this.startCursorArrayAlternate.includes(startCursor) === false) {
    //     this.startCursorArrayAlternate.push(startCursor);

    //     this.props.onLoadMore(
    //       pageInfoAlternate.endCursor,
    //       "ecritureLinesConnectionForTreasury2"
    //     );
    //   }
    // }

    if (
      (pageInfo && pageInfo.hasNextPage === false) &&
      (pageInfoAlternate && pageInfoAlternate.hasNextPage === false)
    ) {
      if (this.state.loadingMore === true)
        this.setState({ loadingMore: false });
      console.log("230 - loadingMore=", this.state.loadingMore);
    }

    if (
      (pageInfo && pageInfo.hasNextPage === true) ||
      (pageInfoAlternate && pageInfoAlternate.hasNextPage === true)
    ) {
      if (this.state.loadingMore === false)
        this.setState({ loadingMore: true });
      console.log("239 - loadingMore=", this.state.loadingMore);
    }
  }

  componentDidMount() {
    // console.log("104 - RentabilityChart.componentDidMount", this);
    this.startCursorArray = [];
    this.startCursorArrayAlternate = [];

    if (!this.props.data) return;

    // this.startCursorArray = [];
    // this.startCursorArrayAlternate = [];

    // ecritureLineCreated
    this.unsubscribeEcritureLineCreated = this.props.subscribeToMore({
      document: ECRITURELINE_CREATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.startCursorArrayAlternate = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineUpdated
    this.unsubscribeEcritureLineUpdated = this.props.subscribeToMore({
      document: ECRITURELINE_UPDATED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        //this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // ecritureLineDeleted
    this.unsubscribeEcritureLineDeleted = this.props.subscribeToMore({
      document: ECRITURELINE_DELETED_SUBSCRIPTION,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.startCursorArrayAlternate = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });

    // lettageDoneCreated
    this.unsubscribeLettageDone = this.props.subscribeToMore({
      document: LETTRAGE_DONE,
      variables: {
        companyId: this.props.companyId
      },

      updateQuery: (prev, { subscriptionData }) => {
        this.startCursorArray = [];
        this.startCursorArrayAlternate = [];
        this.props.refetch();

        if (!subscriptionData.data) {
          return prev;
        }
        return prev;
      }
    });
    return;
  }

  componentWillUnmount() {
    this.startCursorArray = [];
    this.startCursorArrayAlternate = [];

    this.unsubscribeEcritureLineCreated();
    this.unsubscribeEcritureLineUpdated();
    this.unsubscribeEcritureLineDeleted();
    this.unsubscribeLettageDone();
  }

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("310 - getDerivedStateFromProps", props);

    if (props && props.data && props.data.ecritureLinesConnectionForTreasury) {
      state.data = props.data;

      let edges =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForTreasury &&
        state.data.ecritureLinesConnectionForTreasury.edges;

      if (edges) {

        // bank transaction -> bank name
        // _.forEach(edges, o => {
        //   if (o.node && o.node.bankTransaction !== null) {
        //     // console.log("281 - !!!!!!!=", o.node);

        //     if (o.node.tiers === null) {
        //       const fakeTiers = {
        //         id: "fake_" + o.node.bankTransaction.bankAccount.id,
        //         name: o.node.bankTransaction.bankAccount.name,
        //         group: null
        //       }
        //       // o.node.tiers = fakeTiers;
        //     }
        //   }
        // });

        /// TRANSLATIONS.....
        _.forEach(edges, o => {
          if (o.node && o.node.category && o.node.category.ids !== null) {
            // console.log("=>", o.node.category.ids);
            o.node.category.name = props.intl.formatMessage({
              id: o.node.category.ids
            });
          }

          if (
            o.node &&
            o.node.category &&
            o.node.category &&
            o.node.category.categoryFamily &&
            o.node.category.categoryFamily.ids !== null
          ) {
            o.node.category.categoryFamily.name = props.intl.formatMessage({
              id: o.node.category.categoryFamily.ids
            });
          }

          if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
            o.node.tiersClient.name = props.intl.formatMessage({
              id: o.node.tiersClient.name
            });
          }
          if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
            o.node.project.name = props.intl.formatMessage({
              id: o.node.project.name
            });
          }
        });

        edges = _.orderBy(
          edges,
          [
            "node.category.categoryFamily.name",
            "node.tiers.tiersClient.name",
            "node.tiers.name",
            "node.category.name",
            "node.project.name"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.ecritureLinesConnectionForTreasury.edges = edges;
      }
    }

    // Alternate
    if (props && props.data && props.data.ecritureLinesConnectionForTreasury2) {
      state.data = props.data;

      let edgesAlternate =
        state &&
        state.data &&
        state.data.ecritureLinesConnectionForTreasury2 &&
        state.data.ecritureLinesConnectionForTreasury2.edges;

      if (edgesAlternate) {

        // bank transaction -> bank name
        // _.forEach(edgesAlternate, o => {
        //   if (o.node && o.node.bankTransaction !== null) {
        //     // console.log("347 - !!!!!!!=", o.node);

        //     if (o.node.tiers === null) {
        //       const fakeTiers = {
        //         id: "fake_" + o.node.bankTransaction.bankAccount.id,
        //         name: o.node.bankTransaction.bankAccount.name,
        //         // group: null
        //       }
        //       // o.node.tiers = fakeTiers;
        //     }
        //   }
        // });

        /// TRANSLATIONS.....
        _.forEach(edgesAlternate, o => {
          if (o.node && o.node.category && o.node.category.ids !== null) {
            // console.log("=>", o.node.category.ids);
            o.node.category.name = props.intl.formatMessage({
              id: o.node.category.ids
            });
          }

          if (
            o.node &&
            o.node.category &&
            o.node.category &&
            o.node.category.categoryFamily &&
            o.node.category.categoryFamily.ids !== null
          ) {
            o.node.category.categoryFamily.name = props.intl.formatMessage({
              id: o.node.category.categoryFamily.ids
            });
          }

          if (o.node && o.node.tiersClient && o.node.tiersClient.id === "FAKE_ID_CLIENT") {
            o.node.tiersClient.name = props.intl.formatMessage({
              id: o.node.tiersClient.name
            });
          }
          if (o.node && o.node.project && o.node.project.id === "FAKE_ID_PROJECT") {
            o.node.project.name = props.intl.formatMessage({
              id: o.node.project.name
            });
          }
        });

        edgesAlternate = _.orderBy(
          edgesAlternate,
          [
            "node.category.categoryFamily.name",
            "node.tiers.tiersClient.name",
            "node.tiers.name",
            "node.category.name",
            "node.project.name"
          ],
          ["asc", "asc", "asc", "asc", "asc", "asc"]
        );
        state.data.ecritureLinesConnectionForTreasury2.edges = edgesAlternate;
      }
    }
  };

  render() {
    // console.log("TreasuryChart render", this.props);

    const edges =
      this.props.data &&
      this.props.data.ecritureLinesConnectionForTreasury &&
      this.props.data.ecritureLinesConnectionForTreasury.edges;

    const edgesAlternate =
      this.props.data &&
      this.props.data.ecritureLinesConnectionForTreasury2 &&
      this.props.data.ecritureLinesConnectionForTreasury2.edges;

    return (
      <div>
        <ReportingChart
          {...this.props}
          loadingMore={this.state.loadingMore}
          edges={edges}
          edgesAlternate={edgesAlternate}
          negateValues={true}
          type="treasury"
          allowNegative={true}
          showProductColumn={false}
          tabs={["treasury", "charges_incomes"]}
          onRowClick={(id, state, rowInfo, column, instance) => {
            if (rowInfo.original && rowInfo.original.bankTransaction)
              this.props.history.push(
                `/payments/${rowInfo.original.bankTransaction.id}/affectation`
              );
            // console.log("TreasuryChart rowInfo", rowInfo);
            // this.props.history.push(
            //   `/expenses/${rowInfo.original.expense.id}/edit`
            // );
          }}
        />
      </div>
    );
  }
}

export default withRouter(injectIntl(TreasuryChart));
